import {apiResponseTypeEnum} from '../constants/api'

export const getApiResponseErrorMessage = (
  responseTypeEnum,
  messagesPerResponseType = {},
  errorControllerCallback
) =>
  (errorControllerCallback && errorControllerCallback()) ||
  messagesPerResponseType[responseTypeEnum] ||
  (responseTypeEnum === apiResponseTypeEnum.SERVER_ERROR && 'common_error_server_unavailable') ||
  'common_error_generic'



// WEBPACK FOOTER //
// ./src/helpers/api.js